// Conformité — Pipeline ANAH (cycle de vie dossier, bars horizontales).
import { ArrowRight, Loader2 } from "lucide-react";
import { useConformiteFetch } from "./useConformiteFetch";

const COLORS = {
  prospect: "#94a3b8",
  dossier_cree: "#64748b",
  dossier_depose: "var(--oh-stat-blue-text)",
  aides_en_instruction: "var(--oh-stat-amber-text)",
  aides_validees: "#10b981",
  demande_avance: "#8b5cf6",
  avance_payee: "var(--oh-stat-cyan-text)",
  demande_solde: "#ec4899",
  paye: "var(--oh-stat-green-text)",
  refuse_anah: "var(--oh-stat-red-text)",
};

export default function ConformitePipelineAnahWidget() {
  const { data, loading, error } = useConformiteFetch();

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Pipeline ANAH : {error}
      </div>
    );
  }

  const pipeline = data?.pipeline_anah || [];
  if (!pipeline.length) {
    return (
      <div
        className="rounded-xl p-5 h-full text-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Aucune donnée pipeline ANAH.
      </div>
    );
  }

  const maxCount = Math.max(...pipeline.map((d) => d.count), 1);

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="conformite-pipeline-anah-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <ArrowRight className="w-4 h-4" style={{ color: "#10b981" }} />
        Pipeline ANAH — Cycle de vie dossier
      </h3>
      <div className="space-y-2">
        {pipeline.filter((d) => d.count > 0).map((step) => {
          const color = COLORS[step.statut] || "#64748b";
          const pct = (step.count / maxCount) * 100;
          return (
            <div key={step.statut} className="flex items-center gap-3 text-sm">
              <span className="w-32 text-right text-xs truncate" style={{ color: "var(--oh-text-secondary)" }}>
                {step.label}
              </span>
              <div
                className="flex-1 h-7 rounded-md overflow-hidden relative"
                style={{ background: "var(--oh-bg-surface)" }}
              >
                <div
                  className="h-full rounded-md flex items-center px-2 transition-all"
                  style={{
                    width: `${Math.max(pct, 5)}%`,
                    backgroundColor: `${color}30`,
                    borderLeft: `3px solid ${color}`,
                  }}
                >
                  <span className="text-xs font-bold" style={{ color }}>{step.count}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
